// Página de novidades (changelog).
import { CHANGELOG, markChangelogSeen } from "../changelog";
import { feature } from "../features";
import { lang, t } from "../i18n";
import { navigate, type View } from "../router";
import { esc, screen } from "../ui";

export const changelogView: View = (root) => {
  if (!feature("changelog")) {
    navigate("/menu");
    return;
  }
  markChangelogSeen();
  const fmt = new Intl.DateTimeFormat(lang(), { dateStyle: "long", timeZone: "UTC" });
  root.innerHTML = screen(t("changelog.title"), "/menu", CHANGELOG.map((e, i) => `
    <section class="bw-panel bw-stack changelog">
      <div class="bw-panel__header">${t("changelog.version", { v: e.version })}${i === 0 ? ` <span class="board-badge new-badge">${t("changelog.new")}</span>` : ""}</div>
      <p class="bw-dim small" style="margin:0">${esc(fmt.format(new Date(`${e.date}T00:00:00Z`)))}</p>
      <ul>${(e.items[lang()] ?? e.items["pt-BR"]).map((x) => `<li>${esc(x)}</li>`).join("")}</ul>
    </section>`).join(""));
};
